import * as React from "react";
import { useNavigate, useSearchParams } from "react-router";

import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useGetSubcollectionsQuery } from "@/modules/snapshots/snapshotCollection.api";

import { SubcollectionRow } from "./SubcollectionRow";

interface Props {
  snapshotCollectionId: string;
  allCount?: number;
  isOwner: boolean;
  trigger: React.ReactNode;
  contractFamilyProjection?: boolean;
}

export const SubcollectionDropdown = ({
  snapshotCollectionId,
  allCount,
  isOwner,
  trigger,
  contractFamilyProjection = false,
}: Props) => {
  const { data = [] } = useGetSubcollectionsQuery({
    snapshot_collection_id: snapshotCollectionId,
    contract_family_projection: contractFamilyProjection,
  });
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const setActive = (id: string | undefined) => {
    const next = new URLSearchParams(searchParams);
    if (id) next.set("subcollection_id", id);
    else next.delete("subcollection_id");
    navigate({ search: next.toString() });
  };

  const sorted = [...data].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));

  return (
    <Popover>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="start">
        <button
          className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left text-sm hover:bg-muted"
          onClick={() => setActive(undefined)}
        >
          <span>All</span>
          {typeof allCount === "number" && (
            <span className="rounded-full bg-gray-900 px-2 py-0.5 text-xs font-semibold text-white">{allCount}</span>
          )}
        </button>
        {sorted.map(s => (
          <SubcollectionRow key={s.id} subcollection={s} isOwner={isOwner} onSelect={() => setActive(s.id)} />
        ))}
      </PopoverContent>
    </Popover>
  );
};
